/* eslint-disable import/no-anonymous-default-export */
export default {
  common: {
    note: "Note",
    timeline: "Timeline",
    alert: "Alert",
    actions: "Actions",
    continue: "Continue",
    menu: "Menu",
    section: "Section",
    module: "Module",
    field: "Field",
    recordId: "Record ID",
    timestamp: "Timestamp",
    version: "Version",
    registrations: "Registrations",
    bulkActions: "Bulk Actions",
    add: "Add",
    edit: "Edit",
    view: "View",
    warn: "Warning",
    discard: "Discard",
    linkRecord: "Linked Records",
    none: "None",
    collapseMenu: "Collapse Menu",
    expandMenu: "Expand Menu",
    gotIt: "Got it",
    previousValue: "Previous Value",
    addButtonText: "Add {{moduleName}}",
    editButtonText: "Edit {{moduleName}}",
    viewButtonText: "View {{moduleName}}",
    user: "User",
    save: "Save",
    saveAndClose: "Save & Close",
    saveAndNext: "Save & Next",
    cancel: "Cancel",
    delete: "Delete",
    deleteConfirmMsg: "Are you sure you want to delete?",
    no: "No",
    yes: "Yes",
    update: "Update",
    status: "Status",
    newStage: "New Stage",
    lifecycleStage: 'Lifecycle Stage',
    regulatoryStatus: 'Regulatory Status',
    current: 'Current',
    noSet: 'Not Set',
    // stage: "Stage",
    // draft: "Draft",
    comments: "Comments",
    // approved: "Approved",
    lifeCycleUpdate: "Update LifeCycle Stage",
    noResults: "No results found.",
    noDataAvailable: "No Data Available",
    reason: "Reason",
    createdBy: "Created By",
    modifiedBy: "Modified By",
    createdby: "Created by",
    lastModifiedBy: "Last Modified by",
    userOnDate:'{{user}} on {{date}}',
    pleaseEnter: "Please Enter...",
    globalSmartSearch: "Global Smart Search",
    loadingText: "We are loading the data for you. Please wait.",
    search: "Search",
    disable: "Disable",
    download: "Download",
    downloadExcel: "Download as Excel",
    downloadCSV: "Download as CSV",
    downloadPDF: "Download as PDF",
    downloadText:
      "We are currently exporting your data. Please check your downloads once its completed.",
    actionConfirm:'Action Confirmation',
    copyLink: "Copy Link",
    copyLinkSuccess: "Link copied to clipboard",
    copyLinkFailed: "Failed to copy link",
    clone: "Clone",
    cloneRecordConfirm: "Are you sure you want to clone this record?",
    cloneConfirmButton: "Confirm",
    cloneTaskInProgress:
      "Clone task is in progress. Please wait and do not leave this page.",
    cloneSuccessMessage: "The record was cloned successfully.",
    cloneTaskTimeout: "Clone task timed out. Please try again.",
    cloneCreateFailed: "Failed to start clone task.",
    cloneTaskStatusQueryFailed:
      "Failed to get clone task status. Retrying...",
    tip: {
      commonErrorMessage:'There is something wrong with server, please try again later',
      noPrivileges: "You have no privileges",
      addSuccess: "Add successfully.",
      addFailed: "Add failed.",
      registrationAddSuccess: "Registration created successfully.",
      registrationAddFailed: "Registration created failed.",
      addSuccessWithName: "{{moduleName}} created successfully.",
      addFailedWithName: "{{moduleName}} created failed.",
      cancelAdd: "Are you sure you want to cancel? All your data will be lost.",
      updateSuccess: "Update successfully.",
      updateFailed: "Update failed.",
      registrationUpdateSuccess: "Registration updated successfully.",
      registrationUpdateFailed: "Registration updated failed.",
      packageDataHierarchyNotContinuous:
        "Save blocked. The selected Package Data hierarchy is not continuous. Please select the missing intermediate level(s): {{details}}.",
      packageDataHierarchyNotContinuousDetail:
        "{{path}} (missing: {{missing}})",
      updateSuccessWithName: "{{moduleName}} updated successfully.",
      updateFailedWithName: "{{moduleName}} updated failed.",
      deleteSuccess: "Delete successfully.",
      deleteFailed: "Delete failed.",
      deleteSuccessWithName: "{{moduleName}} deleted successfully.",
      deleteFailedWithName: "{{moduleName}} deleted failed.",
      disableRegistrationConfirm:
        "Are you sure you want to make the record disabled?",
      registrationDisableSuccess: "Disabled the record successfully.",
      registrationDisableFailed: "Disabled the record failed.",
      emptyRecordWarning:
        "You are about to save this page with no data entered in any fields. Are you sure you want to create a blank record?",
    },
    identifiers: {
      title: "Manage Identifiers",
      updateSuccessTip: "Identifiers Updated Successfully!",
      updateSuccessTipWithNumber:
        "{{successCount}} out of {{allCount}} record(s) updated successfully!",
      selectAllProcessingTip:
        "This operation involves a large amount of data. The system is processing it in the background and the changes will take effect shortly.",
    },
    dialog: {
      historyVersionTitle: "Historical Version of {{recordId}}",
      recordIdNote: "This record is currently being used in other records. Are you sure you want to proceed?",
      title: "Field Configuration Validation",
      shouldBe: " should be ",
      deleteRecordId: "Record <bold>cannot be deleted</bold> because it has the below dependencies:",
      dependsOn: " depends on ",
      inScope: " in the scope of ",
      deleteValue: 'Delete the value of <bold>{{fieldName}}</bold>.',
      changeValueTo: 'Change the value of <bold>{{fieldName}}</bold> to',
      changeValueToDependsOn: 'Change the value of <bold>{{fieldName}}</bold> to {{newValue}} is not allowed, because: ',
      subUpdateValidationTxt: 'Based on the Configuration Manager, the value of <bold>{{fieldName}}</bold> will be automatically set to the value of <bold>{{linkFieldName}}</bold>.',
      compareValdationMessage: 'The value of <bold>{{fieldName}}</bold> should be {{rule}} the value of <bold>{{childName}}</bold>{{childValue}}.',
      inScopeValidationMessage: 'The value of <bold>{{fieldName}}</bold> should be {{rule}} <bold>{{childName}}</bold>{{childValue}}.',
      mandatoryValidationMesssage: 'The value of <bold>{{fieldName}}</bold> should not be empty.',
      compareCurrentDateMessage: 'The value of <bold>{{fieldName}}</bold> should be {{rule}} the Current Date.',
      childCompareValidationMessage: '<bold>{{childLinkField}}</bold> should be {{message}}.',
      isRequired: '<bold>{{fieldName}}</bold> is Required.',
      min: 'The value of <bold>{{fieldName}}</bold> must be at least {{value}}.',
      max: 'The value of <bold>{{fieldName}}</bold> cannot exceed {{value}}.',
      minLength: 'The value of <bold>{{fieldName}}</bold> must be at least {{value}} characters.',
      maxLength: 'The value of <bold>{{fieldName}}</bold> cannot be longer than {{value}} characters.',
      minDate: 'The value of <bold>{{fieldName}}</bold> cannot be before {{value}}.',
      maxDate: 'The value of <bold>{{fieldName}}</bold> cannot be after {{value}}.',
      dependencyExistMesssage: '<bold>{{fieldName}}</bold> should not be empty.',
      regularMessage: 'The value of <bold>{{fieldName}}</bold> should match the pattern: {{value}}.',
      empty: 'empty.',
      emptyNoDot: 'empty',
    }
  },
  actions: {
    historicalVersions: "Historical Versions",
    conversion: "Conversion",
  },
  conversion: {
    label: "Conversion",
    createNewMrpGroup: "Create new MRP group?",
    reviewSummaryBeforeContinue: "Review the summary below before you continue.",
    currentRecord: "Current record",
    theActionWillCreateNewRecordsAndCannotBeUndone: "The action will create new records and cannot be undone.",
    rms: "RMS",
    cms: "CMS",
    yesCreate: "Yes, create",
    none: "None",
    totalNewRecords: "Total new records",
    cloneSourceVersion: "Clone source version",
    cmsCountriesToCreate: "CMS countries to create",
    chooseCmsCountries: "Choose CMS countries",
    noCountriesFound: "No countries found.",
    npToMrp: "NP to MRP",
    addCms: "Add CMS",
    rup: "RUP",
    stepDown: "Step Down",
    selectAll: "Select All",
    clear: "Clear",
    autoOpenRmsInSeconds: "Opening RMS details in {{seconds}}s in a new tab.",
    autoOpenCancelled: "Auto-open cancelled.",
    openNow: "Open now",
    autoOpenSuccess: "RMS details opened in a new tab.",
    autoOpenBlocked: 'Popup was blocked. Click "Open now" to continue.',
  },
  validation: {
    isRequired: "is required",
    stringTooShortTip: 'The input characters must be at least {{number}}',
    stringTooLongTip: 'The input exceeds the maximum limit of {{number}}',
    regexErrorTip: 'Please Enter A Valid Format',
    numberTooSmallTip: 'The value must be greater than {{number}}',
    numberTooSmallCanEqualTip: 'The value must be greater than or equal to {{number}}',
    numberTooBigTip: 'The value must be less than {{number}}',
    numberTooBigCanEqualTip: 'The value must be less than or equal to {{number}}',
    dateTooEarlyTip: 'The selected date must be later than {{date}}',
    dateTooLateTip: 'The selected date must be earlier than {{date}}',
  },
  popup: {
    unSaveChanges: "Unsaved Changes",
    unSaveChangesConfirm: "You have unsaved changes. Do you want to save them before you leave?",
    lackProductPrivilege: "You lack the required data privileges for Product <bold>{{productName}}</bold> to perform this operation.",
    fieldChange: "Configuration Rule Updated by Admin – Affected Fields Listed Below:",
    fieldChangeTip: "New values have been automatically rendered on the page in accordance with the updated Configuration Rule."
  },
  menu: {
    rtqs: "RTQs",
  },
  registrations: {
    delTitle: "Delete record {{name}}",
    delNote: "A minor draft which is less than 1.0 is not used anywhere. So it can be deleted. Any downstream usage needs to start at 1.0 or greater. Not need to notify other modules via API.",
    delTimeline: "Before the end of Dec",
    header: "Registrations",
    add: "Add Registration",
    class: "Class",
    applicationType: "Application Type",
    edit: "Edit Registration",
    view: "View Registration",
    showActive: "Show Active",
    showInactive: "Show Inactive",
    showDisabled: "Show Disabled",
    disableRegistrationTitle: "Disable Registration",
    orphanDrug: "Orphan Drug",
    regulatoryAuthorizationType: "Regulatory Authorization Type",
    orphanDesignationStatus: "Orphan Designation Status",
    orphanDesignationStatusDate: "Orphan Designation Status Date",
    marketExclusivityStartDate: "Market Exclusivity Start Date",
    orphanDesignationNumber: "Orphan Designation Number",
    pediatricUseIndicator: "Pediatric Use Indicator",
    rapporteur: "Rapporteur",
    version: "Version",
    coRapporteur: "Co-Rapporteur",
    proCrossRefType: "Product Cross-Reference Type",
    proCrossRefResourceId: "Product Cross-Reference Resource ID",
    procedureStartDate: "Procedure Start Date",
    procedureEndDate: "Procedure End Date",
    applicationEndDate: "Application End Date",
    metaDataStatus: "Metadata Status",
    linkedRecords: "Linked Records",
    addPagefirstStep: "Select Products",
    addPageSecondStep: "Choose Countries",
    addPagethirdStep: "Details to Register",
    finish: "Finish",
    back: "Back",
    next: "Next",
    productName: "Product Name",
    countryGroup: "Country Group",
    requiredWithfiledName: "{{filedName}} is required",
    procedureType: "Procedure Type",
    procedureNumber: "Procedure Number",
    LMSCountry: "LMS Country",
    RMSCountry: "RMS Country",
    countrys: "Country(s)",
    MSCountrys: "MS Country(s)",
    CMSCountrys: "CMS Country(s)",
    MSCCountrys: "MSC Country(s)",
    application: "Application",
    athorizationNo: "Athorization No",
    procedure: "Procedure",
    localProductType: "Local Product Type",
    selectedProducts: "Selected Product(s)",
    region: "Region",
    country: "Country",
    classType: "Class",
    editProduct: "Edit Product",
    viewProduct: "View Product",
    updateRegLifeCSuccess: "The registration's lifecycle status has been updated.",
    updateRegulatoryStatusSuccess: "Update regulatory status successfully.",
    localRegistrationCategory: "Local Registration Category",
    referenceState: "Reference State",
    recognitionState: "Recognition State(s)"
  },
  filter: {
    event: {
      label: "Events"
    }
  },
  audit: {
    entityIdentifier: "Entity Identifier",
    auditIdentifier: "Audit Identifier",
    entityName: "Entity Name",
    entityCreatedDate: "Created Date and Time",
    entityModifiedDate: "Modified Date and Time",
    fieldName: "Field Name",
    beforeModification: "Before Modification",
    afterModification: "After Modification",
    operationType: "Operation Type",
    operationDate: "Operation Date and Time",
    note: "Note: This table only contains the fields which were updated during this transaction",
    audit: "Audit",
  },
  product: {
    product: "Product",
    productFamily: "Product Family",
    document: {
      chooseFile: "Choose File",
      switchRadioButton:
        "Moving between the radio buttons will lead to loss of the data",
      deleteDocumentSuccessTip: "Document deleted successfully.",
      updateDocumentSuccessTip: "Document updated successfully.",
      addDocumentSuccessTip: "Document added successfully.",
      editDocument: "Edit Document",
      addDocument: "Add Document",
      documentURL: "Document URL",
      uploadFromLocal: "Upload from Local",
      documentNumber: "Document Number",
      documentName: "Document Name",
      documentId: "Document ID",
      url: "URL",
      confirmDeleteDocument: "Are you sure you want to delete this Document?",
      allowedFileTypes:
        '<b>Note</b> : Allowed File Types "<b>.doc, docx, .pdf, jpeg, .xlsx</b>", Max size: <b>5MB</b>',
      waringAllowedFileTypes: "Please upload files smaller than 5MB",
    },
    file: {
      uploadFileSuccessTip: "File uploaded successfully.",
    },
  },
  rtq: {
    addRtq: "Add RTQ",
    title: "Title",
    category: "Category",
    healthAuthority: "Health Authority",
    query: {
      pluralLabel: "Queries",
      queryStatus: "Query Status",
    },
    workflow: {
      workflow: "Workflow",
      workflowAssginSuccessTipsFirstPart: "Workflow and ",
      workflowAssginSuccessTipsLastPart: "assigned successfully.",
      assginWorkflow: "Assign a Workflow",
      assign: "Assign",
      selectWorkflow: "Select Workflow",
      pickWorkflow: "Please pick a workflow from the below dropdown menu",
    },
    showDisabled: "Show Disabled",
    reasonForDisable: "Reason for Disable",
    comment: "Comment",
    disableRtq: "Disable RTQ",
    disableRtqTitle: "Are you sure you want to make the record disabled?",
    disableRtqSuccessTip: "Disable the record successfully.",
  },
  workflow: {
    workflowLabel: "Workflow",
    reAssociateProcess: "Re-associate",
    associateProcess: "Associate Process",
    initiateProcess: "Initiate Process",
    viewProcess: "View Process",
    terminateProcess: "Terminate Process",
    end: "End",
    endProcess: "End Process",
    Completed: "Complete Task",
    Rejected: "Reject Task",
    completeTask: "Complete Task",
    rejectTask: "Reject Task",
    recallTask: "Recall Task",
    instructions:"Instructions",
    process:'Process',
    task: "Task",
    recall: "Recall",
    complete: "Complete",
    reject: "Reject",
    due:'Due',
    overDue:'Overdue',
    actionSuccessfully:'{{actionLabel}} successfully',
    associatedSuccessfully: "Process associated successfully",
    initiatedSuccessfully: "Process initiated successfully",
    nextStepSuccessfully: "Task completed successfully",
    recallStepSuccessfully: "Task recalled successfully",
    rejectStepSuccessfully: "Task rejected successfully",
    terminateProcessSuccessfully: "Process ended successfully",
    needTerminateFirst:
      "A process is already associated with this product. Would you like to end it and re-associate?",
    lifecycleInProgress:'Process templates cannot be associated or initiated.\nOnly minor versions of records without an ongoing lifecycle workflow are eligible for process association or initiation.',
  },
};
